import { useState } from "react";
import { Routes, Route, Link } from "react-router";
import Main from "./Main";
import Help from "./Help";
import styles from "./navbar.module.css";

export default function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <header className={styles.navbar}>
        <div className={styles.inner}>

          <Link to="/" className={styles.logo}>
            SIVIL LAB
            <span className={styles.logoSub}>Пункт выдачи</span>
          </Link>

          <nav className={styles.links}>
            <Link to="/help" className={styles.link}>
              Возникли трудности?
            </Link>
          </nav>

          <button
            className={styles.burger}
            onClick={() => setIsOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>

        </div>
      </header>

      {/* Overlay */}
      <div
        className={`${styles.overlay} ${isOpen ? styles.overlayActive : ""}`}
        onClick={() => setIsOpen(false)}
      />

      {/* Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.drawerActive : ""}`}>
        <div className={styles.drawerHeader}>
          <span>Меню</span>
          <button onClick={() => setIsOpen(false)}>✕</button>
        </div>

        <Link
          to="/help"
          className={styles.drawerLink}
          onClick={() => setIsOpen(false)}
        >
          Возникли трудности?
        </Link>
      </div>

      {/* Контент */}
      <main>
        <Routes>
          <Route path="/*" element={<Main />} />
          <Route path="/help" element={<Help />} />
        </Routes>
      </main>
    </>
  );
}